// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.92.0-beta.9cdb1dea1',
  revision: '9cdb1dea1',
  branch: 'develop',
  date: 'Fri, 16 Oct 2026 15:53:19 GMT'
};